<template>
  <v-menu
    :offset="14"
  >
    <template #activator="{ props, isActive }">
      <button
        v-bind="props"
        type="button"
        data-testid="account-dropdown-submenu"
        class="user-settings-button"
        :class="{ active: isActive }"
      >
        <span
          v-if="userInitials.length"
          class="user-initials text-body-3"
        >
          {{ userInitials }}
        </span>
        <span class="user-fullname text-body-1">
          {{ userFullName }}
        </span>
        <v-icon
          icon="$chevron-down"
          :size="20"
        />
      </button>
    </template>
    <section class="dropdown-container">
      <AccountDropdownList
        v-if="superuserNavLinks?.length"
        :links="superuserNavLinks"
        @tracking-event="emit('tracking-event', $event)"
      />
      <AccountDropdownList
        :links="settingsNavLinks"
        @tracking-event="emit('tracking-event', $event)"
      />
    </section>
  </v-menu>
</template>

<script setup>
import { computed } from 'vue';
import { storeToRefs } from 'pinia';
import { useAppPlatform } from '@/stores/app/platform';
import { useAppAuthData } from '@/stores/app/authData';
import AccountDropdownList from '@/components/settings/AccountDropdownList.vue';

const emit = defineEmits(['tracking-event']);

const { settingsNavLinks, superuserNavLinks } = storeToRefs(useAppPlatform());
const { authData } = storeToRefs(useAppAuthData());

const userFullName = computed(() => `${authData.value?.firstName} ${authData.value?.lastName}`);

const userInitials = computed(() => {
  if (!userFullName.value.length) return '';
  const splitName = userFullName.value.split(' ');
  const firstLetter = splitName[0].length ? splitName[0][0] : '';

  let lastLetter = '';
  if (userFullName.value.length > 1) {
    lastLetter = splitName[splitName.length - 1].length
      ? splitName[splitName.length - 1][0] : '';
  }

  return `${firstLetter}${lastLetter}`;
});
</script>

<style lang="less" scoped>
.user-settings-button {
  display: inline-flex;
  align-items: center;
  justify-content: space-between;

  .user-initials {
    color: @forest-green;
    width: 32px;
    height: 32px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    background-color: @bg-dark;
  }

  .user-fullname {
    color: @text-white;
    padding: 0px 8px;
  }

  :deep(svg path) {
    fill: @icon-white;
  }

  :deep(.v-icon) {
    transition: 300ms all ease-in-out;
  }

  &.active {
    :deep(.v-icon) {
      transform: rotateZ(180deg);
    }
  }
}

.dropdown-container {
  display: flex;
  gap: 16px;
  background-color: @bg-default;
  border-radius: 4px;
  border: 1px solid @stroke-dark;
  padding: 12px 16px;
  overflow-y: auto;
}
</style>
